export default __webpack_public_path__ + "static/media/NCSenegal.2aeb5172.png";